import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';


function IconMerchant(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
        <path fill="none" d="M0 0h20v20H0z"/>
        <path fill={props.htmlColor || '#000'} d="M14.947 7.75l.466 2.25H4.587l.467-2.25h9.893M16.222 4H3.778v1.5h12.444zm0 2.25H3.778L3 10v1.5h.778V16h7.778v-4.5h3.111V16h1.556v-4.5H17V10zM5.333 14.5v-3H10v3z"/>
      </svg>
    </SvgIcon>
  );
}

export default IconMerchant;